import React, { useState, useEffect } from 'react'
import { AnalyticsEvent, AppData, DynamicContentType, CustomEventType, FloorplanFilter, FormFieldType, MediaType, PageType, PromptOptions, ThumbSize, UnitFilter } from 'app/types'
import { Media, SlideShow, WaterMark, Button } from 'components'
import { IntersectionHelper } from 'views/DynamicPage/IntersectionHelper'
import { Link } from 'react-router-dom'
import { showPrompt } from 'actions/appActions'
import { useAppDispatch } from 'app/hooks'
import { CustomContent } from './CustomContent'
import { States, referralSources } from 'app/constants'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import { LocationLink } from 'views/HomePage/LocationLink'

const location = {
    name: 'Copper Creek Presentation Center',
    numberAndStreet: '138 S. Park Square #101',
    city: 'Fruita',
    provinceState: 'CO',
    postalZipCode: '81521',
    longitudeLatitude: '39.15826840292975, -108.73387470072285',

    address: {
        numberAndStreet: '138 S. Park Square #101',
        city: 'Fruita',
        provinceState: 'CO',
        postalZipCode: '81521',
        longitudeLatitude: '39.15826840292975, -108.73387470072285',
    },
}

const amenitiesElements = [
    {
        title: 'Trails',
        body: 'Enjoy the 2.5 miles of maintained trails woven throughout the site and along Adobe Creek.',
        media: { galleryLink: 'amenities-grid', index: 0, size: 3 },
        tooltip: 'Trails',
        points: [{ x: 91.72, y: 34.44 }],
    },
    {
        title: 'Fiber Internet',
        body: 'Enjoy super fast Internet with fiber to every home.',
        media: { galleryLink: 'amenities-grid', index: 9, size: 3 },
        // points: [{ x: 26.75, y: 23.06 }],
    },
    {
        title: 'Parks',
        body: 'Korima is home to a network of 10 pocket parks, all connected by trails.',
        media: { galleryLink: 'amenities-grid', index: 1, size: 3 },
        points: [{ x: 26.75, y: 23.06 }],
    },
    {
        title: 'Dog Park',
        body: 'Where dogs can let their hair down and run free.',
        media: { galleryLink: 'amenities-grid', index: 2, size: 3 },
        points: [{ x: 82.21, y: 52.22 }],
    },
    {
        title: 'Korima Pond',
        body: 'A serene setting with ample opportunities for bird and wildlife viewing.',
        media: { galleryLink: 'amenities-grid', index: 3, size: 3 },
        points: [{ x: 76.17, y: 75.19 }],
    },
    {
        title: 'Community Garden',
        body: 'Gardening plus friends equals good times.',
        media: { galleryLink: 'amenities-grid', index: 4, size: 3 },
        points: [{ x: 76.58, y: 62.22 }]
    },
    {
        title: 'Fruit Tree Orchard',
        body: 'Enjoy the fresh fruit from a variety of fruit trees such as apple, peach, cherry, plum and apricot.',
        media: { galleryLink: 'amenities-grid', index: 5, size: 3 },
        points: [{ x: 72.84, y: 63.06 }],
    },
    {
        title: 'Pavilion',
        body: 'The perfect setting for a harvest party or an outdoor wine tasting event.',
        media: { galleryLink: 'amenities-grid', index: 6, size: 3 },
        points: [{ x: 80.45, y: 60.28 }],
    },
    {
        title: 'Views',
        body: 'Korima sits below the Colorado National Monument, known for its dramatic red rock formations.',
        media: { galleryLink: 'amenities-grid', index: 7, size: 3 },
        points: [{ x: 89, y: 43.39 }],
    },
]

const amenities = [
    {
        type: DynamicContentType.Grid,
        title: 'Your Community can be the heart of your Wellness Plan',
        body: "Korima’s amenities provide many opportunities to get outside, enjoy nature and also make new friends ",
        expandable: true,
        elements: amenitiesElements
    },
    // {
    //     type: CustomContentType.Blurb,
    //     title: 'Whole Site: Trails and Amenities',
    //     // body: '1. Trails\n\n2. Parks\n\n3. Dog Park\n\n4. Korima Pond\n\n5. Community Garden\n\n6. Fruit Tree Orchard\n\n7. Pavilion\n\n8. Views',
    //     points: [
    //         { x: 91.72, y: 34.44, number: '1', label: 'Trails' },
    //         { x: 26.75, y: 23.06, number: '2', label: 'Parks', },
    //         { x: 82.21, y: 52.22, number: '3', label: 'Dog Park' },
    //         { x: 76.17, y: 75.19, number: '4', label: 'Korima Pond' },
    //         { x: 76.58, y: 62.22, number: '5', label: 'Community Garden' },
    //         { x: 72.84, y: 63.06, number: '6', label: 'Fruit Tree Orchard' },
    //         { x: 80.45, y: 60.28, number: '7', label: 'Pavilion' },
    //         { x: 89.68, y: 41.39, number: '8', label: 'Views' },
    //     ],
    //     media: {
    //         clickable: true,
    //         contain: true,
    //         galleryLink: 'amenities-grid',
    //         size: 8,
    //         index: 8,
    //     },
    // },
    {
        type: DynamicContentType.Points,
        title: 'Whole Site: Trails and Amenities',
        // body: '1. Trails\n\n2. Parks\n\n3. Dog Park\n\n4. Korima Pond\n\n5. Community Garden\n\n6. Fruit Tree Orchard\n\n7. Pavilion\n\n8. Views',
        elements: amenitiesElements,
        size: 75,
        media: [{
            size: 8,
            clickable: true,
            contain: true,
            galleryLink: 'amenities-grid',
            index: 8,
        }],
    }
]


const pastProjects = {
    type: DynamicContentType.Grid,
    title: "Past Projects",
    body: "Discover the beauty of our past projects.",
    expandable: true,
    elements: [
        {
            title: 'Copper Village Apartments',
            body: 'In Grand Junction’s burgeoning North Area. These 1 & 2 Bedroom Bookcliff, Monument & Mesa Apartments epitomize our dedication to quality living. With spacious layouts, stainless steel appliances, and expansive balconies, Copper Village Apartments set the standard for modern comfort and style.',
            media: { galleryLink: 'pastprojects', mediaLink: 'pastprojects_coppervillageapartments' }
        },
        {
            title: 'Copper Creek North',
            body: 'Offering contemporary living and designed for community. Featuring parks, craftsman-style homes, and energy-efficient features.',
            media: { galleryLink: 'pastprojects', mediaLink: 'pastprojects_coppercreeknorth' }
        },
        {
            title: 'Copper Village Townhomes',
            body: 'Luxurious living in a lock-and-leave style with all the coveted finishes of Copper Creek homes.',
            media: { galleryLink: 'pastprojects', mediaLink: 'pastprojects_coppervillagetownhomes' }
        },
        {
            title: 'Mulberry St.',
            body: 'In Fruita, Colorado—where living meets play. Including our newest designs like The Aspen, The Blue Jay, and The Cardinal. With options for single-story living, ample storage, and modern amenities, Mulberry St. offers the perfect blend of comfort and convenience.',
            media: { galleryLink: 'pastprojects', mediaLink: 'pastprojects_mulberryst' }
        }

    ]
}

const aboutKorima = {
    type: DynamicContentType.Blurb,
    title: 'What is Korima?',
    body: `In 2012, Chris and Silas Colman, a father and son team, decided to start a new home building company.\n\nFrom the beginning, they wanted to do more than just build a house to get a check. They had a goal to use their platform as a home builder to help children experiencing hunger and homelessness around the world.\n\nSeveral years before they began building homes, they got involved with a non-profit that helped build an orphanage in the Copper Canyon region of Mexico. The Copper Canyon region is home to a group of indigenous people known as the Tarahumara.\n\nFor the most part,  the Tarahumara live today in the same way they lived a hundred years ago. They do not rely on money to survive. **The key to their survival as a culture is their generosity. This willingess to share what they have with eachother is what they refer to as Korima.**\n\nChris and Silas decided to name their company Copper Creek Builders and committed to donate $2,500 from the sale of every house to several non-profit organizations who are dedicated to building orphanages and caring for children in the Copper Canyon region and around the world. One of those organizations is the Alkare Foundation. Click below to learn more.\n\nVisit [Alkare.org](https://www.alkare.org/)\n\nTo hear stories of Korima happening in past Copper Creek neighborhoods, check out our customer testimonials page.`,
    media: { galleryLink: 'videos', mediaName: 'Korima History', position: 'top', align: 'center' },
    expandable: true,
    links: [{ link: 'testimonials', label: 'See testimonials' }]
}

const aboutUsOld = {
    type: DynamicContentType.Blurb,
    title: 'About Us',
    body: "Copper Creek Builders is a family owned and operated business. We are a father and son team that has been building homes in the Grand Valley for over 30 years. We are proud to be a part of the Grand Valley community and we are committed to building homes that are not only beautiful but also energy efficient and environmentally friendly. We are also committed to giving back to the community and we donate $2,000 from the sale of every house to the Alkare Foundation, a non-profit organization that supports orphanages around the world. We are proud to be a part of the Grand Valley community and we are committed to building homes that are not only beautiful but also energy efficient and environmentally friendly. We are also committed to giving back to the community and we donate $2,000 from the sale of every house to the Alkare Foundation, a non-profit organization that supports orphanages around the world."
}

const aboutUs = [
    {
        type: DynamicContentType.Blurb,
        title: 'We are excited to assist you in building your dream house.',
        body: 'Copper Creek Builders, LLC is a land development and construction company, owned and operated by Chris and Silas Colman, a father-son team who have been in business together since 2002. They begin each project with raw land in order to design a perfect fit between the homes, streets and community features.',
        links: [{ link: 'testimonials', label: 'See testimonials' }]
    },
    pastProjects,
    {
        type: DynamicContentType.Quotes,
        elements: [
            {
                title: 'Chris Colman',
                body: "Chris is a co-owner of Copper Creek Builders, LLC. and manages all construction projects to ensure each one is built to the design and quality standards of the company. Chris got his start in the construction industry in 1972 as a framer and union paid heavy equipment operator. He is a licensed general contractor and has personally managed projects ranging from home remodels to commercial new construction.\n\nIn addition to his real estate experience, he also has 25 years of experience in public speaking, management and marketing. He graduated from Intermountain Bible College with a Bachelors degree in Ministry and was the pastor of Northeast Christian Church for 23 years before he retired and made the switch to real estate.\n\nChris is outdoor enthusiast who has hiked, climbed and cycled through many countries around the world. He is an avid runner and enjoys competing in trail races.",
                header: "Being apart of Copper Creek brings me daily joy and satisfaction because I get to work with an amazing group of talented team members. I'm proud to be apart of a team who takes pride in building a very comfortable, livable, and beautiful home that will last for generations as it brings years of joy to those who will live there.",
                subtitle: "Copper Creek Builders",
                media: [{ galleryLink: 'about', mediaLink: 'chris-colman' }],
            },
            {
                title: "Silas Colman",
                subtitle: "Copper Creek Builders",
                header: "It's been a joy to see our neighborhoods filling up with happy customers over the past few years. I feel fortunate that we can provide housing and at the same time bring people together to create community.",
                body: "Silas is a co-owner of Copper Creek Builders, LLC. He’s been actively involved in many areas of real estate since 2002, including land acquisition and development, construction, property management, finance and marketing. He has been a long time board member for the Alkare Foundation that supports orphanages around the world.\n\nSilas is also a father of 3 but occasionally finds time to enjoy a mountain bike ride.",
                media: [{ galleryLink: "about", mediaLink: "silas-colman" }],
            },
            {
                title: "Naomi Thayer",
                body: "Naomi Thayer is the Marketing Coordinator at Copper Creek Builders. In 2017 she earned her Bachelor’s degree in Business Administration with a double concentration in Marketing and Management from Colorado Mesa University and began working full time with Copper Creek Builders. During her time with the team, Naomi took on the role of Sales Coordinator, providing direct support to customers throughout the process of purchasing a Copper Creek home.\n\nAn avid outdoor enthusiast, Naomi loves capturing stunning views around the world through her photography. Not only does Naomi enjoy spending time outside, but she also finds joy in painting and ultimately cherishing moments with her family.",
                header: "During my time here at Copper Creek I have had the opportunity to meet and interact with countless community members, business professionals, and even those outside of Grand Junction who are looking to relocate. Everyday is a new and exciting adventure and I cant wait to see what the future holds here at Copper Creek.",
                subtitle: "Copper Creek Builders",
                media: [{ galleryLink: "about", mediaLink: "naomi-colman" }],
            },
            {
                title: "Sunni Gagler",
                body: "Sunni joined the Copper Creek team in January 2017. Sunni brings a wealth of experience from a career in finance, accounting, business systems and project management.\n\nShe believes that true professionalism is born from the ability to work smarter, not harder - always being a few steps ahead of the game, and knowing where to look for issues before they arise.  After spending over a decade as the Assistant Controller and Project Control Manager for a US based leading energy infrastructure design and construction contractor, the residential construction industry is second nature to her after spending over 8 years helping build new homes in the Grand Valley.\n\nShe holds a Bachelor of Arts in Business Administration with emphasis in Finance and Economics.\n\nSunni lives in Grand Junction with her husband and daughters.  She enjoys outdoor activities and spends most of her free hours enjoying time with family and friends!",
                header: "When I first met the owners of Copper Creek Builders, I was surprised by their passion for what they do. It feels like nothing was impossible to achieve and I appreciate and love this positivity.  We are very team-driven, and we operate in a way that puts collective goals ahead of individual glory. In the last two years we have grown exponentially, and we continue to succeed because we are a flexible team that can rise to any challenge we may face. Everyone here is smart, energetic, fun to work with, and we are always trying to help each other expand our horizons.  We love what we do, and it shows in the strong relationships we have built with each other, the local municipalities and businesses and of course, our customers.  Never have I been part of a business that truly strives to develop a stronger sense of community.",
                subtitle: "Copper Creek Builders",
                media: [{ galleryLink: "about", mediaLink: "sunni-gagler" }],
            },
            {
                title: "Jessica Gagler",
                body: "Jessica has been with Copper Creek Builders since February 2018.  She is a valuable administrative asset to our team doing everything from blogging to paying the bills.  She’s creative, efficient and organized.  She is in her second year of study at Colorado Mesa University completing her prerequisites so she can apply to the CMU nursing program.  Jessica is planning for a career in nursing with a minor psychology.  Her passion is dance.  She has trained in lyrical, contemporary, jazz, hip hop, ballet, pointe, tap, and modern styles for over eight years.  Jessica loves animals and forensic science.",
                header: "I am very grateful to Copper Creek Builders for allowing me the opportunity to gain work experience. I could not have chosen a better place for my first job. Everyone is nice and always willing to help all the time. Moreover, they treat me as part of the team and support my ideas.  My job here has forced me to step outside my comfort zones and grow. I have learned so many things from interacting with subcontractors, to local government entities, to Buyers.  I love that I am not viewed as merely a teenager, but that my work is important to them.  I work in a great atmosphere with fun and knowledgeable people to learn from.",
                subtitle: "Copper Creek Builders",
                media: [{ galleryLink: "about", mediaLink: "jessica-gagler" }],
            },
            {
                title: "Dustin McElhaney",
                body: "Dustin McElhaney is the Superintendent of Copper Creek Builders, LLC bringing over 30 years of dedicated experience to the construction industry. Throughout his career, Dustin has held various positions including project manager, site supervisor and CEO. His expertise spans residential, commercial, and government projects. He has an extensive background in cabinetry, as well as property and land development. Additionally, Dustin is a licensed subcontractor and draftsman. Dustin is currently managing projects at Copper Creek, where he focuses extensively on attention to detail to ensure every home is built to the highest standards of design and quality craftsmanship.\n\nDustin grew up in Moab Utah and when he is not overseeing construction projects, he enjoys working on classic cars, off-roading, boating, trailing, fly fishing and other recreational outdoor activities. Dustin also enjoys spending time with his family and traveling to new destinations for exciting adventures.",
                header: "Coming Soon!",
                subtitle: "Copper Creek Builders",
                media: [{ galleryLink: "about", mediaLink: "dustin-mcelhaney" }],
            },
            {
                title: "Sue Ottman",
                body: "Sue is the newest member of the Copper Creek Builders team, joining us in 2024 as our New Home Sales Associate for our new, much anticipated Fruita community.  She brings 44 years of experience in the real estate industry, including 14 years in construction, commercial and residential lending. For the past 30 years, Sue has been involved in all facets of the title insurance industry, including closings and title insurance for commercial, multi-site, multi-state transactions, businesses, multi-family, acquisition & development, construction and residential new and existing home sales.  Her most recent title of Experience Director speaks of her dedication to providing the highest level of customer service and satisfaction in all aspects of the real estate transaction.\n\nSue participates and serves actively with local non-profit and industry-related organizations. She has served on the Board of Directors of the Professional Women in Building Council of the HBA of Western Colorado, since the PWB was chartered in 2019.  She is always looking for opportunities to gather, learn and share information with her community.\n\nSue has a new-found love for exploring and travelling with her retired husband and good friends.  Always looking forward to making memories, family activities and gatherings are her happy places.  She finds peace in reading, crafting, and tending her flower and vegetable gardens.",
                header: "I have had the privilege of working the with Copper Creek Builders team and the Colman family since 2002 in different capacities. Now I am truly honored to be a part of the team as we continue to grow communities in the Grand Valley.  The quality of our products is the direct result of the integrity, experience and commitment  each member contributes to the success of our team",
                subtitle: "Copper Creek Builders",
                media: [{ galleryLink: "about", mediaLink: "sue-ottman" }],
            },
            {
                title: "Jim Hoffman",
                body: "Jim made the move to Grand Junction from Illinois in 2020 and quickly became a member of the Copper Creek Builders team, taking on different roles in both single family and commercial construction.He is currently the director of maintenance for the Copper Creek rental division. Jim loves the thrill of the unexpected in his work, relishing the fact that each day brings something new and exciting.\n\nWhen he's not working on-site, Jim can often be found exploring the mountains and taking in the beauty of the area's trails and jeep roads.",
                header: "Coming Soon!",
                subtitle: "Copper Creek Builders",
                media: [{ galleryLink: "about", mediaLink: "jim-hoffman" }],
            },
        ]
    }
]

const moveinready = [
    {
        type: DynamicContentType.Blurb,
        title: "Explore our Move-In-Ready Homes!",
        body: "Why wait months for your dream home? Explore our 'move-in ready' inventory homes and start enjoying everything our community has to offer even sooner.",
        large: true,
        // links: [{ label: 'See Move-In-Ready Homes', pageType: PageType.Sitemap, filters: { [FloorplanFilter.Availability]: ['Inventory'] }}],
        media: [{ galleryLink: 'moveinready', index: 1, orientation: 'portrait', thumbnail: { galleryLink: 'moveinready', index: 2 } }]
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Columbine Floorplan',
        body: "* **Price:** $539,000\n\n* **Completion Date:** OCT 15\n\n* **Address:** 1961 TOMOCHIC DR\n\n* **Lot Number:** 24\n\n* **Interior design package:** Scandinavian Villa",
        // body: "* Price: $539,000\n\n* Completion Date: OCT 15\n\n* Address: 1961 TOMOCHIC DR\n\n* Lot Number: 24\n\n* Interior design package: Scandinavian Villa\n\n",
        media: [{ mediaLink: 'construction-columbine.jpg', size: 8 }],
        links: [
            { label: 'View Lot', pageType: PageType.Sitemap, dataLink: 'columbine' },
            { label: 'VR Tour', media: { mediaLink: 'coppercreek/Korima/Columbine' } }
        ],
        spacing: 'minimal',
    },
    {
        type: DynamicContentType.Grid,
        media: [{ galleryLink: 'moveinready-columbine' }],
        size: 3,
        expandable: true,
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Larkspur Floorplan',
        body: "* **Price:** $496,000\n\n* **Completion Date:** OCT 3\n\n* **Address:** 1949 TOMOCHIC DR\n\n* **Lot Number:** 23\n\n* **Interior design package:** European Farmhouse\n\n",
        media: [{ mediaLink: 'construction-larkspur.jpg', size: 8 }],
        links: [
            { label: 'View Lot', pageType: PageType.Sitemap, dataLink: 'larkspur' },
            { label: 'VR Tour', media: { mediaLink: 'coppercreek/Korima/Larkspur' } }
        ],
        spacing: 'minimal',
    },
    {
        type: DynamicContentType.Grid,
        media: [{ galleryLink: 'moveinready-larkspur' }],
        size: 3,
        expandable: true,
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Aspen Floorplan',
        body: "* **Price:** $539,000\n\n* **Completion Date:** OCT 8\n\n* **Address:** 1946 TOMOCHIC DR\n\n* **Lot Number:** 36\n\n* **Interior design package:** Colorado Cottage\n\n",
        // media: [{ galleryLink: 'moveinready-larkspur', index: 0, size: 8 }],
        media: [{ mediaLink: 'construction-aspen.jpg', size: 8 }],
        links: [
            { label: 'View Lot', pageType: PageType.Sitemap, dataLink: 'aspen' },
            { label: 'VR Tour', media: { mediaLink: 'coppercreek/Korima/Aspen' } }
        ],
        spacing: 'minimal',
    },
    {
        type: DynamicContentType.Grid,
        media: [{ galleryLink: 'moveinready-larkspur' }],
        size: 3,
        expandable: true,
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Aster Floorplan - 1',
        body: "* **Price:** $475,000\n\n* **Completion Date:** NOV 7\n\n* **Address:** 1937 TOMOCHIC DR\n\n* **Lot Number:** 22\n\n* **Interior design package:** Colorado Cottage\n\n",
        media: [{ mediaLink: 'construction-aster-1.jpg', size: 8 }],
        links: [
            { label: 'View Lot', pageType: PageType.Sitemap, dataLink: 'aster' },
            { label: 'VR Tour', media: { mediaLink: 'coppercreek/Korima/Aster' } }
        ],
        spacing: 'minimal',
    },
    {
        type: DynamicContentType.Grid,
        media: [{ galleryLink: 'moveinready-aster-1' }],
        size: 3,
        expandable: true,
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Aster Floorplan - 2',
        body: "* **Price:** $475,000\n\n* **Completion Date:** NOV 20\n\n* **Address:** 1913 TOMOCHIC DR\n\n* **Lot Number:** 20\n\n* **Interior design package:** Colorado Cottage\n\n",
        media: [{ mediaLink: 'construction-aster-2.jpg', size: 8 }],
        links: [
            { label: 'View Lot', pageType: PageType.Sitemap, dataLink: 'aster' },
            { label: 'VR Tour', media: { mediaLink: 'coppercreek/Korima/Aster' } }
        ],
        spacing: 'minimal',
    },
    {
        type: DynamicContentType.Grid,
        media: [{ galleryLink: 'moveinready-aster-2' }],
        size: 3,
        expandable: true,
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Daisy Floorplan',
        body: "* **Price:** $450,000\n\n* **Completion Date:** NOV 20\n\n* **Address:** 1925 TOMOCHIC DR\n\n* **Lot Number:** 21\n\n* **Interior design package:** Scandinavian Villa\n\n",
        media: [{ mediaLink: 'construction-daisy.jpg', size: 8 }],
        links: [
            { label: 'View Lot', pageType: PageType.Sitemap, dataLink: 'daisy' },
            // { label: 'VR Tour', media: { mediaLink: 'coppercreek/Korima/Aster'} }
        ],
        spacing: 'minimal',
    },
    {
        type: DynamicContentType.Grid,
        media: [{ galleryLink: 'moveinready-daisy' }],
        size: 3,
        expandable: true,
    }
]

const homedesign = [
    {
        type: DynamicContentType.Blurb,
        title: 'Home Design Themes',
        body: 'Explore the different home design styles available at Korima by Copper Creek Builders. From modern to traditional, we have a style that fits your lifestyle.'
    },
    {
        type: DynamicContentType.Grid,
        title: 'European Farmhouse',
        underline: false,
        body: 'The European Farmhouse is an alternative to the very popular modern farmhouse aesthetic. It reintroduces some of the more classic elements seen in older farmhouses by incorporating more color and lots of natural tones and textures, while still achieving the familiar feel of the modern styles.',
        media: [{ galleryLink: 'homedesign-ef' }],
        size: 3,
        expandable: true,
    },
    {
        type: DynamicContentType.Grid,
        title: 'Scandanavian Village',
        underline: false,
        body: 'The Scandinavian Villa embraces a bright, open, and airy feeling for those that prefer a minimalistic look without their space feeling sterile.\n\nInspiration was taken from classic Scandinavian styles as well as incorporating pops of color to ground the house in more local southwestern aesthetics.',
        media: [{ galleryLink: 'homedesign-sv' }],
        size: 3,
        expandable: true,
    },
    {
        type: DynamicContentType.Grid,
        title: 'Colorado Cottage',
        underline: false,
        body: 'The Colorado Cottage imitates all the character of a cozy mountain home. Its rich colors embrace both classic elements and bolder accents.',
        media: [{ galleryLink: 'homedesign-cc' }],
        size: 3,
        expandable: true,
    }
]

const welcome = [
    {
        type: DynamicContentType.Blurb,
        title: 'WTF: Welcome To Fruita',
        body: "Fruita, CO has been a hidden gem in the minds of locals but the word is out. Below is a list of accolades Fruita has received over the past few years. Take some time online to learn about all Fruita has to offer. Then come to Fruita and experience it for yourself!\n\n1. Fruita is one of Outdoor Elevation Magazine's \"[Colorado's Top Adventure Town](http://www.elevationoutdoors.com/november-issue-elevation-outdoor-live/)\" four years in a row: [2015](http://www.elevationoutdoors.com/colorados-2015-top-adventure-towns/), [2016](http://www.elevationoutdoors.com/november-issue-elevation-outdoor-live/), [2017](https://www.elevationoutdoors.com/go-outside/colorados-top-adventure-towns-2/), [2018](https://www.elevationoutdoors.com/go-outside/the-2018-top-adventure-towns/)\n2. Fruita was the “[12th America’s 20 Coolest Outdoor Towns](http://matadornetwork.com/trips/americas-20-coolest-towns-outdoor-adventure/)” two years in a row: 2015 & 2016\n3. Fruita is \“[5th Safest Place in Colorado](http://www.movoto.com/co/safest-places-in-colorado/)\”\n4. Fruita named #4 in the \“[Best Places for Young Families in Colorado](http://www.nerdwallet.com/blog/cities/economics/best-places-for-young-families-in-colorado/)\“\n5. The North Fruita Desert (18 Road) is ranked 8th in the \"[Best Mountain Bike Trails in the World](https://www.singletracks.com/the-best-mountain-bike-trails-in-the-world/)\" by Singletracks\n6. Kokopelli Trail System is ranked 31st in the \"[Best Mountain Trails in the World](https://www.singletracks.com/the-best-mountain-bike-trails-in-the-world/)\" by Singletracks\n7. Kokopelli Loops in Fruita, CO was ranked \"[Top Highest Rated Rides](http://www.mtbproject.com/featured/Rides)\” by MTB Project\n8. Fruita named \“[Top 10 Mountain Bike Destinations in North America](http://www.singletracks.com/blog/mtb-trails/the-top-10-mountain-bike-destinations-in-north-america/)\” by Singletracks\n9. Fruita named in \“[10 Best Bucket List Adventure Trips](http://www.usatoday.com/story/travel/destinations/10greatplaces/2014/06/20/10-best-adventures/10591591/)\” by USA Today\n10. Fruita is one of the \"[Best Biking Towns in the West](https://www.sunset.com/travel/outdoor-adventure/biking-towns#biking-towns-fruita-co)\" in 2019 according to Sunset Magazine\n11. Fruita named one of the \“[50 best places to live in the US](https://money.com/best-places-to-live/fruita-colorado/)\” in 2024  by Money.com"
    },
    {
        type: DynamicContentType.Grid,
        title: 'Nearby Destinations',
        body: 'Here is a list of a few Outdoor destinations within a 1 hour Drive of Fruita, CO',
        split: '6-6',
        expandable: true,
        elements: [
            {
                title: 'Polluck Bench Trail',
                subtitle: '12 minutes away',
                body: "Rugged terrain, vibrant flora, towering cliffs, thrilling challenges, breathtaking vistas.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'polluck_bench_trail', size: 6 },
            },
            {
                title: 'Colorado National Monument',
                subtitle: '15 minutes away',
                body: "Experience ancient canyons, towering monoliths, breathtaking vistas amidst Fruita's rugged beauty.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'colorado_national_monument', size: 6 }
            },
            {
                title: 'Kokopelli Trail Network',
                subtitle: '10 minutes away',
                body: "Discover adventure amidst winding desert trails, offering thrilling experiences and unforgettable vistas.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'kokopelli_trail_network', size: 6 },
            },
            {
                title: 'North Desert Trail Network',
                subtitle: '15 minutes away',
                body: "Navigate diverse terrain for exhilarating hikes, mountain biking amid stunning desert vistas in Fruita's North Desert.",
                media: [
                    { galleryLink: 'welcome-grid', mediaLink: 'north_desert_trail_network_1', size: 6 },
                    // { galleryLink: 'welcome-grid', mediaLink: 'north_desert_trail_network_2' },
                ],
            },
            {
                title: 'Adobe Creek Golf Course',
                subtitle: '5 minutes away',
                body: "Experience pristine fairways, breathtaking views at Adobe Creek Golf Course, nestled in scenic Fruita amid Colorado's natural beauty.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'adobe_creek_golf_course', size: 6 },
            },
            {
                title: 'Palisade Wine Country',
                subtitle: '25 minutes away',
                body: "Palisade Wine Country offers award-winning wines amidst Colorado's stunning beauty, with vineyards stretching across scenic landscapes.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'palisade_wine_country', size: 6 },
            },
            {
                title: 'Wild Mustang Preserve and Mt Garfield',
                subtitle: '20 minutes away',
                body: "Rugged wilderness, iconic peaks, pristine landscapes. Witness majestic wild mustangs in their natural habitat.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'wild_mustang_preserve', size: 6 },
            },
            {
                title: 'Palisade Rim Trail',
                subtitle: '20 minutes away',
                body: "Breathtaking views of Palisade's vineyards, majestic Colorado River, rugged terrain, and scenic vistas await on Palisade Rim Trail.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'palisade_rim_trail', size: 6 },
            },
            {
                title: 'The Grand Mesa: Worlds Largest Flat Top Mountain and home to 300 Freshwater lakes',
                subtitle: '1 hour',
                body: "Rugged beauty, serene waters, outdoor haven, breathtaking vistas, abundant natural wonders await in Colorado's wilderness.",
                media: { galleryLink: 'welcome-grid', mediaLink: 'grand_mesa', size: 6 },
            },
            // {
            //     title: 'Independence Monument',
            //     subtitle: '25 minutes away',
            //     body: "Unveil majestic sandstone tower in Colorado National Monument, with thrilling challenges and awe-inspiring panoramas.",
            //     media: { galleryLink: 'welcome-grid', mediaLink: 'independence_monument' }
            // },
        ]
    },
    {
        ...aboutKorima,
        links: [{
            link: 'about',
            label: 'Learn More',
            icon: 'fas fa-arrow-right'
        }]
        /*expand: {
            link: 'about',
            label: 'Learn More',
            icon: 'fas fa-arrow-right'
        }*/
    },
    /*{
        ...homedesign[0],
        ...homedesign[1],
        expand: {
            link: 'homedesign',
            label: 'Learn More',
            icon: 'fas fa-arrow-right'
        }
    }*/
    /*{
        ...aboutUs[0],
        expand: {
            link: 'aboutus',
            label: 'Learn More',
            icon: 'fas fa-arrow-right'
        }
    }*/

]
const testimonials = [
    {
        type: DynamicContentType.Blurb,
        title: "Community Testimonials",
        body: "See what our residents have to say about Copper Creek Builders and the communities they've built.",
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Anna and Stephen",
        body: "\"I truly love this neighborhood. Come live here!\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Copper Creek really is set up differently. It fosters a community environment."
2. "We have great relationships with our neighbors. It's been refreshing."
3. "One big thing we love about Copper Creek is its multiculturalism."
4. "Having a neighborhood that reflects multiculturalism is important."
5. "I truly love this neighborhood. Come live here!"`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Community: Anna and Stephen' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Patti and Frank",
        align: 'center',
        body: "\"The concept of community or village, where everybody has their own space yet looks out for each other, isn't normal. With a park in front, you have your private space and community support.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "We all refer to it as our village. We're just Community-Based and get along really well."
2. "The concept of community or village, where everybody has their own space yet looks out for each other, isn't normal. With a park in front, you have your private space and community support."
3. "As a community, we utilized the front park for an open-air barbecue. It was stress-relieving and fun, bringing the whole village together."
4. "One neighbor hosted an Outdoor Theater on Friday evenings. Everyone brought lawn chairs, and we watched movies together. We're looking forward to more activities like that."`,
        media: { galleryLink: 'testimonials', size: 6, position: 2, mediaName: 'Community: Patti and Frank' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Lisa and Eric",
        body: "\"In the first six months here, I made more friends than I did in 15 years in my previous subdivision. The thought put into creating this community with trails and porches encouraged social interaction tremendously.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Community is being on the front porch, watching people walk by with their dogs and children. One of the real joys is talking with neighbors, meeting their families, and getting to know each other."
2. "In the first six months here, I made more friends than I did in 15 years in my previous subdivision. The thought put into creating this community with trails and porches encouraged social interaction tremendously."
3. "One of the best benefits is the design where every home has a front porch facing a park, trail, or open space. We received tremendous support from neighbors during our medical issues."
4. "Neighbors were willing to help with tasks like driving to appointments or bringing meals. We didn't have that kind of relationship in our previous community."
5. "The added bonus is having more face-to-face contact, knowing neighbors' names and pets' names, and having social support in this community."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Community: Lisa and Eric' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Alex and Abby",
        body: "\"Our neighborhood park is a hub for connection; families gather, kids play, and friendships flourish around bubbles and chalk.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "The layers of community are profound; from simple tasks like taking out trash to deep friendships, it's about looking after each other."
2. "Over 75% of the community is familiar to us; shared values drive us to care for our neighbors as we do for our homes."
3. "Our neighborhood park is a hub for connection; families gather, kids play, and friendships flourish around bubbles and chalk."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, position: 2, mediaName: 'Community: Alex and Abby' },
    },
    {
        type: DynamicContentType.Blurb,
        title: "Purchasing Process",
        body: "See what our residents have to say about their experience with Copper Creek Builders.",
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Lisa and Eric",
        body: "\"The purchasing process at Copper Creek North was remarkably simple. From home design to financing, dealing with Naomi in-house made it seamless. The knowledge of the builders and subcontractors ensured a smooth journey from start to finish.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "The purchasing process at Copper Creek North was remarkably simple. From home design to financing, dealing with Naomi in-house made it seamless. The knowledge of the builders and subcontractors ensured a smooth journey from start to finish."
2. "Having different plans to choose from and pre-designed interior and exterior packages was a huge appeal. With a busy schedule, it was a relief not to worry about coordinating every detail. It was absolutely fantastic!"
3. "Copper Creek offers a streamlined experience. You can customize your home without the hassle. From design to completion, it's a journey guided by expertise, making your dream home a reality."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Purchasing: Lisa and Eric' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Anna and Stephen",
        body: "\"The process for purchasing a home in Copper Creek was super smooth. It was refreshing, quick, and pain-free. Dealing with real estate agents and loan requirements was minimal. It was a headache and pain-free process, I have to say.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "The process for purchasing a home in Copper Creek was super smooth. It was refreshing, quick, and pain-free. Dealing with real estate agents and loan requirements was minimal. It was a headache and pain-free process, I have to say."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, position: 2, mediaName: 'Purchasing: Anna and Stephen' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Alex and Abby",
        body: "\"Copper Creek made the home-buying process surprisingly easy and stress-free.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "The buying process with Copper Creek was interesting. We saw our home bare bones, knew it'd be ours eventually. Communication with Silus was key; he understood our attachment to the home. Seamless collaboration with Fidelity made the whole process easy for first-time buyers like us."
2. "Working with a preferred team streamlined everything. No more guessing games or background checks. It was straightforward, from purchase price to execution. Copper Creek made the home-buying process surprisingly easy and stress-free."
3. "Copper Creek's process was a breeze. With clear communication and a trusted team, buying our home felt natural. Silus understood our connection to the home, making the transition seamless. Thanks to Fidelity, even as first-time buyers, everything fell into place effortlessly."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Purchasing: Alex and Abby' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Patti and Frank",
        body: "\"Communication during the sales process was excellent. Despite our son being out of state, everything went smoothly electronically. Naomi's involvement made it easy to choose what we wanted. Closing was a breeze, with all questions answered satisfactorily.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "The sales procedure was very good for us, especially with our son's involvement. Despite him being out of state, communication was smooth. Choosing everything for the home, with your involvement, Naomi, was easy. Even the closing went very smoothly, with all questions answered."
2. "Our son purchasing the home for us, despite being out of state, was seamless. Communication electronically made it easy. Naomi, you were instrumental in coordinating with both us and him. From selection to closing, everything went smoothly."
3. "Communication during the sales process was excellent. Despite our son being out of state, everything went smoothly electronically. Naomi's involvement made it easy to choose what we wanted. Closing was a breeze, with all questions answered satisfactorily."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, position: 2, mediaName: 'Purchasing: Patti and Frank' },
    },
    {
        type: DynamicContentType.Blurb,
        title: "Service Testimonials",
        body: "See what our residents have to say about the quality of their Copper Creek Builders home.",
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Lisa and Eric",
        body: "\"The quality of our home's build was outstanding, but with any project, issues may arise. Copper Creek developers were incredibly responsive, tackling problems without hesitation. Their willingness to go above and beyond left me truly impressed.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
2. "Copper Creek developers dealt with our home issues promptly and without pushback. They went above and beyond, handling significant work with ease. Their responsiveness and dedication were truly impressive throughout the process."
3. "I'm blown away by Copper Creek's response to our home issues. They didn't hesitate to address significant work, handling cleanup and more without question. Their level of dedication and responsiveness was truly impressive."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Quality: Lisa and Eric' },
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Experience Testimonials',
        body: "See what our residents have to say about recommending Copper Creek Builders to others.",
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Dee",
        body: "\"Living in Copper Creek has been a blessing. The community spirit is tangible; neighbors become friends, even dog-sitters. It's more than just a neighborhood; it's a place where everyone cares. Trust your instincts; Copper Creek is where you belong.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Walking into Copper Creek felt like fate. Naomi made the transition smooth; her kindness eased my emotional move. The community here is incredible; everyone supports each other. From safety to camaraderie, it's been an amazing experience. Trust your instincts; Copper Creek is home."
2. "Copper Creek is more than a community; it's a family. The open concept homes, vaulted ceilings—it felt perfect. My little dog Wesley loves it too; it's safe, with friendly neighbors. From dog walks to late nights, it's a place to call home."
3. "Living in Copper Creek has been a blessing. The community spirit is tangible; neighbors become friends, even dog-sitters. It's more than just a neighborhood; it's a place where everyone cares. Trust your instincts; Copper Creek is where you belong."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Experience: Dee' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Alex and Abby",
        body: "\"The real value of Copper Creek is in its sense of community. Walking the neighborhood, chatting with neighbors—it's about connection. Growing families find it hard to leave; the sense of belonging here is unmatched.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "This community is about knowing and being known. Copper Creek draws people together, beyond just houses. Regular neighborhood walks, meet and greets, garage sales—it's about belonging. Leaving is hard; even with a growing family, it's tough to imagine life elsewhere."
2. "Copper Creek isn't just a neighborhood; it's a community where connections matter. Open minds and regular interactions build bonds. It's not about closing garage doors; it's about opening hearts to belonging."
3. "The real value of Copper Creek is in its sense of community. Walking the neighborhood, chatting with neighbors—it's about connection. Growing families find it hard to leave; the sense of belonging here is unmatched."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, position: 2, mediaName: 'Experience: Alex and Abby' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Patti and Frank",
        body: "\"Coming from a home on larger acreage, we found a sense of community here. New buyers will be treated like family.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Seriously consider Copper Creek for its innate community concepts. It's like being in a small town, where neighbors naturally come together. From shared maintenance to conversations while shoveling snow, it offers a rested sense of belonging."
2. "Living in Copper Creek is like being part of a village. Coming from larger acreage, we found a sense of community here. It's economically sound, offering more than expected. New buyers will be treated like family."
3. "Copper Creek offers more than just a home; it's a village where neighbors connect naturally. From the welcoming entrance to shared responsibilities, it sets the tone for community living. Welcome to Copper Creek, where belonging begins."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Experience: Patti and Frank' },
    },
    {
        type: DynamicContentType.Blurb,
        title: 'Why Customers Chose Copper Creek Builders',
        body: "See what our residents have to say about why they chose Copper Creek Builders.",
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Lisa and Eric",
        body: "\"With single level floorplans and spacious layouts, these homes are perfect for aging in place.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "We wanted a single-level home, and Copper Creek offered diverse floor plans to choose from. With an irrigation system and zero-scaped landscaping, maintenance is a breeze—even when we're away. The spacious layout gives us flexibility, making it more usable than our previous, larger home."
2. "Copper Creek North's architectural style and abundant parks and trails drew us in. Every home has a porch, fostering social interaction. From design to colors, we love every aspect. It's not just a home; it's a lifestyle."
3. "Choosing Copper Creek North was easy. With single-level options and spacious layouts, it's perfect for aging in place. The community's architectural style, parks, and trails create an inviting atmosphere. It's not just about a house; it's about finding your ideal home."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Choice: Lisa and Eric' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Alex and Abby",
        body: "\"Copper Creek offered what we needed: Space to grow and low maintenance. The architecture and overall aesthetic reminded us of mature homes and really stood out to us.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Before Copper Creek, we moved around rentals. We sought a home to grow into, with less maintenance. Community was key for us. Copper Creek's aesthetic, reminiscent of mature homes, appealed to us. It's about character, growth, and community."
2. "Choosing Copper Creek meant finding a home for our expanding family and busy lives. The focus on community and low maintenance was crucial. Its aesthetic, reminiscent of mature homes, stood out to us."
3. "Copper Creek offered what we needed: space to grow and less maintenance. Its focus on community resonated with us. The aesthetic, akin to mature homes, drew us in. It's more than just a home; it's a place to thrive."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, position: 2, mediaName: 'Choice: Alex and Abby' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Patti and Frank",
        body: "\"A single level home was a must. Also the open layout and low maintenance appealed to us.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "We downsized from a large home on Glade Park to Copper Creek North. Close proximity to hospitals was vital after my quadruple bypass. With knee and hip issues, a single-level home was a must. The open design and low maintenance appealed to us."
2. "Copper Creek's layout, especially the kitchen, was a selling point. We valued the flexibility offered in customizing our home. From proximity to hospitals to the single-level design, every aspect made Copper Creek North our ideal choice."
3. "Choosing Copper Creek North meant finding comfort and convenience. The layout, especially the kitchen, was tailored to our needs. Flexibility and low maintenance were key factors. It's not just a home; it's a place where comfort meets customization."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Choice: Patti and Frank' },
    },
    {
        type: DynamicContentType.Blurb,
        title: "Before Copper Creek",
        body: "See what our residents have to say about their experience before moving to Copper Creek Builders.",
    },

    {
        type: DynamicContentType.Blurb,
        subtitle: "Lisa and Eric",
        body: "\"Copper Creek provided the ideal solution for our retirement needs. No more yard work or maintenance hassles—just a new, hassle-free home to enjoy our golden years.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Retiring meant finding a TurnKey home with low maintenance. Copper Creek offered just that—new, with minimal upkeep. Say goodbye to yard work and hello to hassle-free living."
2. "Downsizing to Copper Creek was the perfect choice for retirement. With a new, low-maintenance home, we could focus on enjoying life without the stress of upkeep."
3. "Copper Creek provided the ideal solution for our retirement needs. No more yard work or maintenance hassles—just a new, hassle-free home to enjoy our golden years."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Before: Lisa and Eric' },
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Stephen and Anna",
        body: "\"In California, our cramped house was a constant fixer-upper. With four kids, we needed space and a break from repairs. Copper Creek provided just that—a new, hassle-free home where we could focus on family, not fixing.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Moving from California, we craved a change. After waiting a year, we finally found our home in Copper Creek. With six of us in a cramped 1,000 square feet, we needed space—especially for homeschooling. Copper Creek offered the new, low-maintenance home we dreamed of."
2. "In California, our cramped house was a constant fixer-upper. With four kids, we needed space and a break from repairs. Copper Creek provided just that—a new, hassle-free home where we could focus on family, not fixing."
3. "Copper Creek was our dream come true—a spacious, new home without constant repairs. With four kids, we needed the space to homeschool and grow. After waiting patiently, we found our perfect fit in Copper Creek."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, position: 2, mediaName: 'Before: Stephen and Anna' },
    },
    {
        type: DynamicContentType.Blurb,
        title: "Employee Testimonials",
        body: "See what our employees have to say about working at Copper Creek Builders.",
    },
    {
        type: DynamicContentType.Blurb,
        subtitle: "Naomi and Tanner",
        body: "\"Working at Copper Creek Builders gave me firsthand insight into the quality of homes they build. It wasn't just a tagline; it was evident in every stage of the process, even years later.\"",
        bodyOld: `(please select one via feedback, or provide a new one)
1. "Copper Creek felt like home and a park all in one; with pocket parks and walking trails, it was an easy decision to purchase a house here, financially and for our future."
2. "Living here is a stark contrast from the busy city life; it's quiet, safe, and perfect for raising a family. We have a community of all generations, even babysitters!"
3. "We love our Park View home; smaller yard, but with pocket parks nearby, we have the flexibility to explore without yard maintenance tying us down every weekend."
4. "Working at Copper Creek Builders gave me firsthand insight into the quality of homes they build. It wasn't just a tagline; it was evident in every stage of the process, even years later."`,
        align: 'center',
        media: { galleryLink: 'testimonials', size: 6, mediaName: 'Employee: Naomi and Tanner' },
    }
]


export const CopperCreekContentData = {
    'home': [
        // {
        //     type: CustomContentType.Header,
        //     media: [{ galleryLink: 'preview', index: 0 }],
        //     alt: true,
        // },
        // {
        //     type: CustomContentType.ProjectInfo,
        //     title: 'Register Now',
        //     /*subtitle: 'April 2024',
        //     location: {
        //         name: 'Copper Creek Presentation Center',
        //         address: {
        //             numberAndStreet: '138 S. Park Square #101',
        //             city: 'Fruita',
        //             provinceState: 'CO',
        //             postalZipCode: '81521',
        //         },
        //     },*/
        //     // body: "Introducing Korima, an upcoming project featuring new detached homes with high-quality finishes in a neighborhood with a heart. With large lots, scenic walking trails alongside a serene creek, and a dedicated dog park, our community offers the perfect blend of luxury and nature. Mark your calendars for late April 2024 and register now for updates on this exciting project!",
        //     // body: "Register to join our VIP list.\n\nBe the first to see the new plans, finishes and early pricing.\n\nThe first round of lots will be released, exclusively to the VIP list by June 22, 2024.\n\nCopper Creek Builders is offering a broad selection of their award-winning home plans for you to choose from.",
        //     // body: "Register to join our VIP list.\n\nBe the first to see the new plans, finishes and early pricing.\n\nCopper Creek Builders is offering a broad selection of their award-winning home plans for you to choose from.",
        //     body: "Register to unlock the interactive site map, floorplans, virtual tours & interior design details.",
        //     links: [{ label: 'Register', link: 'register' }],
        //     media: [{ galleryLink: 'gallery', index: 1 }]
        // },
        // {
        //     type: CustomContentType.Blurb,
        //     title: "Welcome to Korima",
        //     body: "Copper Creek Builders introduces Korima, Fruita’s newest wellness community, offering award winning home designs, surrounded by parks and trails. Located just minutes from world class hiking, biking and Fruita’s charming downtown.",
        //     large: true,
        //     media: { galleryLink: 'videos', mediaName: 'New Copper Creek Homes', position: 'bottom', align: 'center' },
        // },
        // {
        //     type: CustomContentType.Blurb,
        //     title: "Single Family Detached Homes",
        //     body: "Copper Creek Builders is offering a broad selection of their award-winning home designs. Each plan showcases exceptional architecture, is built to the highest construction standards and comes with professionally designed, high end finishes. Here you can have the beauty and function of a custom home without the custom home price.",
        //     large: true,
        // },
        // // {
        //     // ...moveinready[0],
        //     // ...moveinready[1],
        //     /*expand: {
        //         label: 'Learn More',
        //         link: 'move-in-ready',
        //         icon: 'fas fa-arrow-right'
        //     }*/
        // // },
        // /*{
        //     type: CustomContentType.Map,
        //     alt: true,
        // },*/
        // ...amenities,
        // ...welcome,
        // {
        //     type: CustomContentType.Items,
        //     title: "Continue Exploring...",
        //     elements: [
        //         {
        //             title: 'Register Now',
        //             media: { galleryLink: 'explore-more', index: 0 },
        //             body: "Register to join our VIP list\n\nBe the first to see the new plans, finishes and early pricing.\n\nThe first round of lots will be released, exclusively to the VIP list by June 22, 2024.\n\nCopper Creek Builders is offering a broad selection of their award-winning home plans for you to choose from.",
        //             links: [{ label: 'Register', link: 'register', focus: true }],
        //         },
        //         {
        //             title: 'About Korima',
        //             media: { galleryLink: 'explore-more', index: 1 },
        //             body: "Learn more about Korima",
        //             links: [{ label: "Go", link: 'about', focus: true }],
        //         },
        //         {
        //             title: 'Neighborhood',
        //             media: { galleryLink: 'explore-more', index: 2 },
        //             body: 'Explore the neighborhood and surrounding area of Korima.',
        //             links: [{ label: "Go", link: 'neighborhood', focus: true }],
        //         },
        //         /*{
        //             title: 'Sales Office',
        //             media: { galleryLink: 'info-explore', index: 2 },
        //             body: "Information about our sales office location and hours of operation.",
        //             links: [{ label: "Go", link: 'contact', focus: true }],
        //         },*/
        //     ],
        //     full: true,
        // }

    ],
    'neighborhood': [{
        type: DynamicContentType.Neighbourhood,
        title: 'Neighbourhood Points of Interest',
        media: [{ mediaLink: 'coppercreek-neighbourhood.kml', default: '1' }],
    }],
    'amenities': amenities,
    'about': [
        /*{
            type: CustomContentType.Header,
            alt: true,
            media: [{
                galleryLink: 'about', index: 0
            }]
        },*/
        aboutKorima,
    ],
    'aboutus': [
        {
            type: DynamicContentType.Header,
            alt: true,
            media: [{
                galleryLink: 'about', index: 1
            }]
        },
        ...aboutUs,
    ],
    // 'register-hubspot': [
    //     /*{
    //         type: CustomContentType.Header,
    //         media: [{
    //             galleryLink: 'highlight', index: 1
    //         }]
    //     },*/
    //     {
    //         type: CustomContentType.Event,
    //         title: 'Register for Korima',
    //         media: [{ galleryLink: 'videos', mediaName: 'Welcome to Korima', position: 'top', align: 'center' }],
    //         elements: [
    //             {
    //                 title: 'LOCATION',
    //                 location,
    //             },
    //             {
    //                 title: 'DATE',
    //                 body: 'April 2024',
    //             }
    //         ],
    //         dividerAfter: true,
    //     },
    //     {
    //         type: CustomContentType.Form,
    //         body: "Register below and we will send you more information about Korima by Copper Creek Builders",
    //         subtitle: "Fields marked with a * are required",
    //         requestType: AnalyticsEvent.EventRegistration,
    //         redirect: '#thankyou-register',
    //         formOptions: {
    //             submitMessage: 'Register',
    //             tags: ['register'],
    //         },
    //         hubspotOptions: {
    //             region: "na1",
    //             portalId: "2858522",
    //             formId: "fe6e80c7-d7b6-4bd9-91d2-1ef12132e124"
    //         },
    //     },
    // ],
    'register-old': [
        /*{
            type: CustomContentType.Header,
            media: [{
                galleryLink: 'highlight', index: 1
            }]
        },*/
        {
            type: DynamicContentType.Event,
            title: 'Register for Korima',
            media: [{ galleryLink: 'videos', mediaName: 'Welcome to Korima', position: 'top', align: 'center' }],
            elements: [
                {
                    title: 'LOCATION',
                    location,
                },
                {
                    title: 'DATE',
                    body: 'April 2024',
                }
            ],
            dividerAfter: true,
        },
        {
            type: DynamicContentType.Form,
            body: "Register below and we will send you more information about Korima by Copper Creek Builders",
            subtitle: "Fields marked with a * are required",
            requestType: AnalyticsEvent.ProjectRegistration,
            redirect: '#thankyou-register',
            submit: 'Register',
            formOptions: {
                // submitToHubspot: true,
                tags: ['register'],
                successMessage: 'Thanks for your interest in our newest community, Korima, in the heart of Fruita, CO. Keep checking your inbox for exclusive updates!'
                // successMessage: 'Thank you for registering for the Copper Creek Launch Event!'
            },
            // hubspotOptions: {
            //     region: "na1",
            //     portalId: "2858522",
            //     formId: "fe6e80c7-d7b6-4bd9-91d2-1ef12132e124"
            // },
            fields: [
                {
                    id: 'firstname',
                    label: 'FIRST NAME',
                    required: true,
                    size: 2,
                    isHubspot: true,
                },
                {
                    id: 'lastname',
                    label: 'LAST NAME',
                    required: true,
                    size: 2,
                    isHubspot: true,
                },
                {
                    id: 'email',
                    label: 'EMAIL',
                    required: true,
                    size: 4,
                    isHubspot: true,
                },
                {
                    id: 'phone',
                    label: 'PHONE',
                    required: true,
                    inputProps: { phone: true },
                    size: 2,
                    isHubspot: true,
                },
                {
                    id: 'zip',
                    label: 'ZIP CODE',
                    required: false,
                    size: 1,
                    breakAfter: true,
                    isHubspot: true,
                },
                {
                    id: 'what_best_describes_you_',
                    label: 'WHAT BEST DESCRIBES YOU?',
                    dropdown: ['Home Shopper', 'Renter', 'Copper Creek Homeowner', 'Real Estate Professional', 'Other', 'Copper Creek Rental Tenant'],
                    extra: 'What best describes you',
                    size: 2,
                    isHubspot: true,
                },
                {
                    id: 'how_did_they_find_cc_',
                    label: 'HOW DID YOU HEAR ABOUT US?',
                    dropdown: [
                        'Walk-in',
                        { label: 'Web Search', value: 'Website' }, { label: 'Zillow', value: 'Zillo' }, 'Realtor', 'Billboard', 'Referral/Friend', 'Other', 'Radio', 'Newspaper'],
                    required: false,
                    other: true,
                    select: 'Select one option',
                    extra: 'How did you hear about us',
                    size: 2,
                    isHubspot: true,
                },
                {
                    id: 'consent',
                    label: "By clicking this box or by completing this Registration Form for Korima by Copper Creek Builders, I expressly provide my consent to receive electronic messages from Copper Creek Builders and its affiliated companies retroactively, today and in the future for any projects by Copper Creek Builders. I understand that I may withdraw my consent by unsubscribing anytime.",
                    required: true,
                    size: 4
                }
            ],
        },
    ],
    'register': [
        /*{
            type: CustomContentType.Header,
            media: [{
                galleryLink: 'highlight', index: 1
            }]
        },*/
        {
            type: DynamicContentType.Event,
            title: 'Register for Korima',
            media: [{ galleryLink: 'videos', mediaName: 'Welcome to Korima', position: 'top', align: 'center' }],
            elements: [
                {
                    title: 'LOCATION',
                    location,
                },
                {
                    title: 'DATE',
                    body: 'April 2024',
                }
            ],
            dividerAfter: true,
        },
        {
            type: DynamicContentType.Form,
            body: "Register below and we will send you more information about Korima by Copper Creek Builders",
            subtitle: "Fields marked with a * are required",
            requestType: AnalyticsEvent.ProjectRegistration,
            redirect: '#thankyou-register',
            submit: 'Register',
            formOptions: {
                submitToHubspot: true,
                tags: ['register'],
                successMessage: 'Thanks for your interest in our newest community, Korima, in the heart of Fruita, CO. Keep checking your inbox for exclusive updates!'
                // successMessage: 'Thank you for registering for the Copper Creek Launch Event!'
            },
            hubspotOptions: {
                // useEmbedded: true,
                region: "na1",
                portalId: "2858522",
                formId: "fe6e80c7-d7b6-4bd9-91d2-1ef12132e124"
            },
            fields: [
                {
                    id: 'firstname',
                    label: 'FIRST NAME',
                    required: true,
                    size: 2,
                    isHubspot: true,
                },
                {
                    id: 'lastname',
                    label: 'LAST NAME',
                    required: true,
                    size: 2,
                    isHubspot: true,
                },
                {
                    id: 'email',
                    label: 'EMAIL',
                    required: true,
                    size: 4,
                    isHubspot: true,
                },
                {
                    id: 'phone',
                    label: 'PHONE',
                    required: true,
                    inputProps: { phone: true },
                    size: 1,
                    isHubspot: true,
                },
                {
                    id: 'zip',
                    label: 'ZIP CODE',
                    required: false,
                    size: 1,
                    breakAfter: true,
                    isHubspot: true,
                },
                {
                    id: 'what_best_describes_you_',
                    label: 'WHAT BEST DESCRIBES YOU?',
                    dropdown: ['Home Shopper', 'Renter', 'Copper Creek Homeowner', 'Real Estate Professional', 'Other', 'Copper Creek Rental Tenant'],
                    extra: 'What best describes you',
                    size: 1,
                    isHubspot: true,
                },
                // {
                //     id: 'how_did_they_find_cc_',
                //     label: 'HOW DID YOU HEAR ABOUT US?',
                //     dropdown: [
                //         'Walk-in',
                //         { label: 'Web Search', value: 'Website' }, { label: 'Zillow', value: 'Zillo' }, 'Realtor', 'Billboard', 'Referral/Friend', 'Other', 'Radio', 'Newspaper'],
                //     required: false,
                //     other: true,
                //     select: 'Select one option',
                //     extra: 'How did you hear about us',
                //     size: 2,
                //     isHubspot: true,
                // },
                {
                    id: 'consent',
                    label: "By clicking this box or by completing this Registration Form for Korima by Copper Creek Builders, I expressly provide my consent to receive electronic messages from Copper Creek Builders and its affiliated companies retroactively, today and in the future for any projects by Copper Creek Builders. I understand that I may withdraw my consent by unsubscribing anytime.",
                    required: true,
                    size: 4
                }
            ],
        },
    ],
    // 'thankyou-register': [
    //     {
    //         type: CustomContentType.Event,
    //         title: 'Register for Korima',
    //         media: [{ galleryLink: 'videos', mediaName: 'Welcome to Korima', position: 'top', align: 'center' }],
    //         elements: [
    //             {
    //                 title: 'LOCATION',
    //                 location,
    //             },
    //             {
    //                 title: 'DATE',
    //                 body: 'April 2024',
    //             }
    //         ],
    //         dividerAfter: true,
    //     },
    //     {
    //         type: CustomContentType.Blurb,
    //         body: `Thank you for registering for the Copper Creek Launch Event!`,
    //         animated: false
    //     },
    // ],
    'contact': [
        {
            type: DynamicContentType.Header,
            media: [{ galleryLink: 'highlight', index: 1 }]
        },

        {
            type: DynamicContentType.Event,
            title: 'Sales Office',
            elements: [
                {
                    title: 'LOCATION',
                    location,
                },
                {
                    title: 'HOURS OF OPERATION',
                    body: "| | |\n| -- | -- |\n| Monday — Friday: | 8am - 4pm |\n| Saturday — Sunday: | By appointment only |",
                }
            ],
        },
        {
            type: DynamicContentType.Blurb,
            dividerBefore: true,
            title: "Contact Us",
            body: "Call Us: 970-462-1646\n\nEmail Us: Sue@CopperCreekLife.com",
            links: [{ label: 'Book a Meeting', link: 'https://meetings.hubspot.com/sue-ottman/sue-ottman' }]//{ label: 'Visit The PropertyLinq', organization: true }],
        },
        {
            type: DynamicContentType.Blurb,
            dividerBefore: true,
            title: "Request Information",
            body: "Want to learn more about Korima by Copper Creek Builders?\n\nContact us today and we will be happy to answer any questions you may have.",
            links: [{ label: 'Request Info', link: '#request' }]//{ label: 'Visit The PropertyLinq', organization: true }],
        }
        /*{
            type: CustomContentType.Blurb,
            title: 'Contact Us',
            body: "We're here to help! Please fill out the form below and we'll get back to you as soon as possible.",
        }*/

    ],
    'testimonials': [
        {
            type: DynamicContentType.Header,
            media: [{ galleryLink: 'testimonial', index: 0 }],
            title: 'Community'
        },
        ...testimonials,
        pastProjects,
    ],
    'homedesign': [
        {
            type: DynamicContentType.Header,
            title: 'Home Design',
            media: [{ galleryLink: 'homedesign', index: 0 }],
        },
        ...homedesign,
    ],
    'virtualtours': homedesign,
    // 'move-in-ready': [
    //     {
    //         type: DynamicContentType.Header,
    //         title: 'Move-In-Ready Homes',
    //         media: [{ galleryLink: 'moveinready', index: 0 }],
    //     },
    //     ...moveinready,
    // ],
    'footer': [
        {
            type: DynamicContentType.Footer,
            title: 'COME VISIT US',
            subtitle: 'Copper Creek Presentation Center',
            elements: [
                {
                    title: 'Address',
                    location: location
                },
                {
                    title: 'Hours',
                    body: 'Monday — Friday: 8am - 4pm\n\nSaturday — Sunday: By appointment only',
                }
            ]
        },
        {
            type: DynamicContentType.Footer,
            title: 'GET IN TOUCH',
            links: [
                {
                    label: 'Contact Us',
                    link: 'contact'
                },
            ]
        },
    ]
}